import "./Successstories.css";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SSimg1 from "../img/SSimg1.png";
import SSimg2 from "../img/SSimg2.png";
import SSimg3 from "../img/SSimg3.png";
import SSimg4 from "../img/SSimg4.png";
import SSMM1 from "../img/kavitha.png";
import SSMM2 from "../img/sheray.png";
import SSMM3 from "../img/farhan.png";
import SSMM4 from "../img/arun.png";
import SSMM5 from "../img/vijay.png";
import SSV1 from "../img/mt1.png";
import SSV2 from "../img/mt2.png";
import SSV3 from "../img/mt3.png";
import userAvatar from "../img/user-avatar.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllSuccessStories } from "../redux/successStorySlice";
import Loader from "./Loader";

/* ─── Google Fonts ───────────────────────────────────────────────────────── */
const _fl = document.createElement("link");
_fl.rel = "stylesheet";
_fl.href =
  "https://fonts.googleapis.com/css2?family=Gloock&family=Poppins:wght@400;500;600&display=swap";
document.head.appendChild(_fl);

/* ─── DATA ───────────────────────────────────────────────────────────────── */

const stories = [
  {
    id: 1,
    names: "Divya & Suresh",
    quote: "Sometimes, love can return when you least expect it.",
    image: SSimg1,
  },
  {
    id: 2,
    names: "Priya & Vikram",
    quote: 'It started with a "Hi"… and somehow never stopped.',
    image: SSimg2,
  },
  {
    id: 3,
    names: "Ananya & Rohan",
    quote:
      "Not all love stories begin with excitement—some begin with understanding.",
    image: SSimg3,
  },
  {
    id: 4,
    names: "Lakshmi & Karthik",
    quote: "Some matches feel like they were written long before they happen.",
    image: SSimg4,
  },
  {
    id: 5,
    names: "Meera & Arjun",
    quote: "Two worlds, one heartbeat. That's what forever feels like.",
    image: SSimg1,
  },
  {
    id: 6,
    names: "Sneha & Rahul",
    quote: "We found home in each other before we found a home together.",
    image: SSimg2,
  },
  {
    id: 7,
    names: "Kavya & Nikhil",
    quote: "Patience brought us here. Love kept us here.",
    image: SSimg3,
  },
  {
    id: 8,
    names: "Pooja & Aditya",
    quote: "Every conversation felt like coming home.",
    image: SSimg4,
  },
];

/*
  Section 3 gallery — structured to match reference image exactly:
  LEFT column:  card 0 (tall), card 1 (tall)
  RIGHT column: card 2 (wide, full width top)
                card 3 + card 4 (two small, side by side bottom)
*/



const CARDS_PER_PAGE = 4;
const TOTAL_PAGES = Math.ceil(stories.length / CARDS_PER_PAGE);

/* ─── SHARED HOOK ────────────────────────────────────────────────────────── */
function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold },
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

/* ═══════════════════════════════════════════════════════════════════════════
   ROOT COMPONENT
═══════════════════════════════════════════════════════════════════════════ */
export default function SuccessStories() {
  const {t , i18n} = useTranslation();
  const [heroVisible, setHeroVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [sectionVisible, setSectionVisible] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState("next");
  const navigate = useNavigate();
  const heroRef = useRef(null);
  const sectionRef = useRef(null);
  const dispatch = useDispatch();
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(false);
  const allSuccessStories = useSelector((state) => state.successStories.stories);

  useEffect(() => {
    const t = setTimeout(() => setHeroVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setSectionVisible(true);
      },
      { threshold: 0.15 },
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  const goTo = (page) => {
    if (animating || page === currentPage) return;
    setDirection(page > currentPage ? "next" : "prev");
    setAnimating(true);
    setTimeout(() => {
      setCurrentPage(page);
      setAnimating(false);
    }, 380);
  };

  const visibleStories = stories?.slice(
    currentPage * CARDS_PER_PAGE,
    currentPage * CARDS_PER_PAGE + CARDS_PER_PAGE,
  );

    useEffect(() => {
    // dummy data
    // setStories([
    //   {
    //     id: 1,
    //     coupleName: "Rahul & Priya",
    //     description: "Happy married life",
    //     image: "",
    //   },
    // ]);
    setLoading(true);
    dispatch(fetchAllSuccessStories()).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    console.log('allSuccessStories:', allSuccessStories);
    
    setStories(allSuccessStories);
  }, [allSuccessStories]);

  return (
    <>
    <div className="ss-page" data-lang={i18n.language}> 
    { loading ? <Loader /> : '' }
      {/* ══════════ SECTION 1 — Hero ══════════ */}
      <section ref={heroRef} className={`hero ${heroVisible ? "visible" : ""}`}>
        <div className="hero-bg" />
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">
            {t("ss_hero_title")}
          </h1>
        </div>
        <div className="hero-scroll-indicator">
          <div className="scroll-line" />
        </div>
      </section>

      {/* ══════════ SECTION 2 — Story Cards ══════════ */}
      <section className="stories-section" ref={sectionRef}>
        <div className={`section-header ${sectionVisible ? "visible" : ""}`}>
          <h2 className="section-title1">
            {t("ss_hero_sub1")}
          </h2>
          <p className="section-subtitle">
            {t("ss_hero_sub2")}
          </p>
        </div>

        <div className="cards-wrapper">
          <div
            className={`cards-grid ${animating ? (direction === "next" ? "animating-next" : "animating-prev") : ""}`}
          >
            {stories?.map((story, i) => (
              <StoryCard
                key={story._id}
                story={story}
                index={i}
                sectionVisible={sectionVisible}
              />
            ))}
          </div>
        </div>

        <div className="dots">
          {Array.from({ length: TOTAL_PAGES }).map((_, i) => (
            <button
              key={i}
              className={`dot ${i === currentPage ? "active" : ""}`}
              onClick={() => goTo(i)}
              aria-label={`Go to page ${i + 1}`}
            />
          ))}
        </div>
      </section>

      {/* ══════════ SECTION 3 ══════════ */}
      <Section3 />

      {/* ══════════ SECTION 4 ══════════ */}
      <Section4 />

      {/* ══════════ SECTION 5 ══════════ */}
      <Section5 />

      {/* ══════════ SECTION 6 — CTA Banner ══════════ */}
      <Section6 navigate={navigate} />
          </div>
    </>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   SECTION 2 — Story Card
═══════════════════════════════════════════════════════════════════════════ */
function StoryCard({ story, index, sectionVisible }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!sectionVisible) return;
    const t = setTimeout(() => setVisible(true), index * 120 + 200);
    return () => clearTimeout(t);
  }, [sectionVisible, index]);
   const imageUrl = story?.image
  ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${story.image}`
  : userAvatar || "/default-avatar.png";
  console.log('imageUrl,', imageUrl);

  return (
    <div className={`story-card ${visible ? "visible" : ""}`}>
      <img
        src={imageUrl}
        alt={story.coupleName}
        className="card-image"
        loading="lazy"
        onError={(e) => {
        e.target.onerror = null; // prevent infinite loop
        e.target.src = userAvatar; // your fallback image
      }}
      />
      <div className="read-story">
        <div className="card-names">{story.coupleName}</div>
        <p className="card-quote">{story.description}</p>
        <button className="card-cta" onClick={() => navigate(`/story/${story._id}`)}>
          READ STORY →
        </button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   SECTION 3 — Moments & Memories
   GalleryCard is its own component → hooks always at top level (no .map bug)
═══════════════════════════════════════════════════════════════════════════ */
function GalleryCard({ item, index, sizeClass }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setTimeout(() => setVisible(true), index * 120);
          obs.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [index]);

  return (
    <div ref={ref} className={`s3-card ${sizeClass} ${visible ? "vis" : ""}`}>
      <img
        src={item.image}
        alt={item.names}
        className="s3-img"
        loading="lazy"
      />
      <div className="s3-overlay" />
      <div className="s3-caption">
        <p className="s3-quote">{item.quote}</p>
        <div className="s3-names">{item.names}</div>
      </div>
    </div>
  );
}

function Section3() {
  const [headerRef, headerVis] = useInView(0.2);
  const {t} = useTranslation();
  
const galleryLeft = [
  {
    id: 1,
    names: t("ss_couple2"),
    quote: t("ss_quote2"),
    image: SSMM1,
  },
  {
    id: 2,
    names: t("ss_couple3"),
    quote: t("ss_quote3"),
    image: SSMM3,
  },
];

const galleryRightWide = {
  id: 3,
  names: t("ss_couple1"),
  quote:t("ss_quote1") , 
  image: SSMM2,
};

const galleryRightBottom = [
  {
    id: 4,
    names: t("ss_couple4"),
    quote:
      t("ss_quote4"),
    image: SSMM4,
  },
  {
    id: 5,
    names: t("ss_couple5"),
    quote: t("ss_quote5"),
    image: SSMM5,
  },
];

  return (
    <section className="s3">
      {/* Header */}
      <div ref={headerRef} className={`s3-header ${headerVis ? "vis" : ""}`}>
        {<h2 className="s3-title">{t("ss_moments_title")}</h2>}
        <p className="s3-sub">{t("ss_moments_sub")}</p>
      </div>

      {/*
        Grid wrapper
        ┌──────────────┬──────────────────────────────────┐
        │  LEFT COL    │  RIGHT COL                       │
        │  card-tall   │  card-wide (full width)          │
        │  card-tall   │  card-small | card-small         │
        └──────────────┴──────────────────────────────────┘
      */}
      <div className="s3-grid">
        {/* LEFT COLUMN — 2 tall cards stacked */}
        <div className="s3-left-col">
          <GalleryCard
            item={galleryLeft[0]}
            index={0}
            sizeClass="s3-card-tall"
          />
          <GalleryCard
            item={galleryLeft[1]}
            index={1}
            sizeClass="s3-card-tall"
          />
        </div>

        {/* RIGHT COLUMN — 1 wide card on top, 2 small cards below */}
        <div className="s3-right-col">
          <GalleryCard
            item={galleryRightWide}
            index={2}
            sizeClass="s3-card-wide"
          />
          <div className="s3-right-bottom">
            <GalleryCard
              item={galleryRightBottom[0]}
              index={3}
              sizeClass="s3-card-small"
            />
            <GalleryCard
              item={galleryRightBottom[1]}
              index={4}
              sizeClass="s3-card-small"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   SECTION 4 — Quote Wall
═══════════════════════════════════════════════════════════════════════════ */
function Section4() {
  const [headRef, headVis] = useInView(0.2);
  const [gridRef, gridVis] = useInView(0.1);
  const {t} = useTranslation();

const floatingQuotes = [
  t("ss_tag2"),
  t("ss_tag3"),
  t("ss_tag4"),
  t("ss_tag5"),
  t("ss_tag6"),
  t("ss_tag7"),
  t("ss_tag8"),
  t("ss_tag9"),
  t("ss_tag10"),
];

  const [particles] = useState(() =>
    Array.from({ length: 16 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      size: `${2 + Math.random() * 2.5}px`,
      duration: `${9 + Math.random() * 12}s`,
      delay: `${Math.random() * 10}s`,
      bottom: `${Math.random() * 25}%`,
    })),
  );

  return (
    <section className="s4">
      <div className="s4-particles" aria-hidden="true">
        {particles.map((p) => (
          <div
            key={p.id}
            className="s4-particle"
            style={{
              left: p.left,
              bottom: p.bottom,
              width: p.size,
              height: p.size,
              animationDuration: p.duration,
              animationDelay: p.delay,
            }}
          />
        ))}
      </div>

      <h2 ref={headRef} className={`s4-headline ${headVis ? "vis" : ""}`}>
       {t("ss_tag1")}
      </h2>

      <div ref={gridRef} className="s4-quotes-container">
        {floatingQuotes.map((q, i) => (
          <p
            key={i}
            className={`s4-quote-item ${gridVis ? "vis" : ""}`}
            style={{ transitionDelay: gridVis ? `${i * 0.09}s` : "0s" }}
          >
            {q}
          </p>
        ))}
      </div>
      <div className="s4-bottom-spacer" />
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   SECTION 5 — Video Thumbnails
═══════════════════════════════════════════════════════════════════════════ */
function Section5() {
  const [headerRef, headerVis] = useInView(0.2);
  const [gridRef, gridVis] = useInView(0.1);
  const {t} = useTranslation();
  const videos = [
  { id: 1, title: t("ss_album1"), image: SSV1 },
  { id: 2, title: t("ss_album2"), image: SSV2 },
  { id: 3, title: t("ss_album3"), image: SSV3 },
];
  return (
    <section className="s5">
      <div ref={headerRef} className={`s5-header ${headerVis ? "vis" : ""}`}>
        <h2 className="s5-title">{t("ss_gallery_title")}</h2>
        <p className="s5-sub">
          {t("ss_gallery_sub")}
        </p>
      </div>

      <div ref={gridRef} className="s5-grid">
        {videos.map((v, i) => (
          <div
            key={v.id}
            className={`s5-card ${gridVis ? "vis" : ""}`}
            style={{ transitionDelay: gridVis ? `${i * 0.15}s` : "0s" }}
          >
            <img
              src={v.image}
              alt={v.title}
              className="s5-img"
              loading="lazy"
            />
            <div className="s5-overlay" />
            <div className="s5-play" aria-label="Play video">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
            <div className="s5-caption">{v.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   SECTION 6 — Begin Your Forever Today (CTA Banner)
═══════════════════════════════════════════════════════════════════════════ */
function Section6({ navigate }) {
  const [ref, vis] = useInView(0.2);
  const {t} = useTranslation();
  return (
    <section ref={ref} className={`s6 ${vis ? "vis" : ""}`}>
      {/* Layered gradient background */}
      <div className="s6-bg" />

      {/* Animated gold heart — bottom center */}
      <svg
        className="s6-heart"
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="heartGold" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#D4AF37" stopOpacity="1" />
            <stop offset="50%" stopColor="#f5d67a" stopOpacity="1" />
            <stop offset="100%" stopColor="#D4AF37" stopOpacity="0.6" />
          </linearGradient>
        </defs>
        {/* Heart path centered in 200×200 viewBox */}
        <path
          className="s6-heart-path"
          d="M100 160
             C 60 130, 20 100, 20 65
             C 20 40, 40 25, 60 25
             C 75 25, 88 35, 100 50
             C 112 35, 125 25, 140 25
             C 160 25, 180 40, 180 65
             C 180 100, 140 130, 100 160 Z"
        />
      </svg>

      {/* Main content */}
      <div className="s6-content">
        <p className="s6-eyebrow">{t("ss_cta_title")}</p>

        <h2 className="s6-title">
          {t("ss_cta_sub1")}
        </h2>

        <p className="s6-subtitle">
          {t("ss_cta_sub2")}
        </p>

        <button className="s6-btn" onClick={() => navigate('/matches')}>
          {t("ss_cta_btn")}
        </button>
      </div>
    </section>
  );
}
